module.exports = __webpack_public_path__ + "static/media/feishu4.a1e8d091.mp4";